
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.986 7.76a1.15 1.15 0 01-.865-.39L.216 1.794A.923.923 0 011.602.574l4.29 4.877a.125.125 0 00.188 0L10.37.575a.923.923 0 111.386 1.22L6.852 7.367a1.155 1.155 0 01-.866.392z","fill":"#161616","fill-opacity":".88"}})])
          )
        }
      }
    